import { lineHeights, textStyles } from './types';

const FALLBACK_FONT = 'IM100';

const typographyGenerator = (type: textStyles, lineHeight: lineHeights, theme: any) => {

	const fontForType = theme.typography[type];
	if (!fontForType) {
		console.log('No Theme for typography: ', type, theme.typography);
		return `
			font-size: ${theme.typography[FALLBACK_FONT].fontSize};
			font-weight: ${theme.typography[FALLBACK_FONT].fontWeight};
			font-family: ${theme.typography[FALLBACK_FONT].fontFamily};
			letter-spacing: ${theme.typography[FALLBACK_FONT].letterSpacing};
			line-height: ${theme.typography.lineHeight[lineHeight]};
		`;
	}
	return `
		font-size: ${fontForType.fontSize};
		font-weight: ${fontForType.fontWeight};
		font-family: ${fontForType.fontFamily};
		letter-spacing: ${fontForType.letterSpacing};
		line-height: ${theme.typography.lineHeight[lineHeight]};
	`;
};

export default typographyGenerator;
